import React from 'react';
import { BottomSheet } from '../Common/BottomSheet';
import StoryProgressPanel from './StoryProgressPanel';

export const STORY_PROGRESS_SHEET_TITLE = 'Story progress';

/**
 * Phone sheet for the same lane panel the desktop slot uses (#2075).
 * Closing it leaves the page underneath mounted.
 */
export default function StoryProgressSheet({
  open,
  onClose,
  storyId,
  textScale = 1,
}) {
  return (
    <BottomSheet isOpen={open} onClose={onClose} title={STORY_PROGRESS_SHEET_TITLE}>
      <StoryProgressPanel storyId={storyId} textScale={textScale} />
    </BottomSheet>
  );
}
